<template>
  <b-card class="table-trigger">
    <div class="float-right mb-3 ">
      <b-form-checkbox v-model="enableTrigger" value:true v-if="user.Permissions.habilitarservicosgatilhos.allowed"
        class="checkbox" name="check-button" switch>
        <b>{{ $t('servico-de-gatilho') }}</b>
      </b-form-checkbox>
    </div>
    <div class="filter-trigger">
      <div>
        <label for="filter-trigger">{{ $t('filtro') }}</label>
        <input type="text" id="filter-trigger" class="ml-1" v-model="triggerFilter" />
      </div>
      <label>{{ $t('indicadores-configurados') }} <strong>{{ items.length }}</strong> </label>
    </div>

    <b-table class="table-limit" hover responsive striped small :items="items" :fields="fields" sort-by="id">
      <template v-slot:cell(vlv)="row">
        <b-form-checkbox v-model="row.item.vlv" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(vlt)="row">
        <b-form-checkbox v-model="row.item.vlt" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(vfr)="row">
        <b-form-checkbox v-model="row.item.vfr" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(vmd)="row">
        <b-form-checkbox v-model="row.item.vmd" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(vmt)="row">
        <b-form-checkbox v-model="row.item.vmt" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(alt)="row">
        <b-form-checkbox v-model="row.item.alt" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(ald)="row">
        <b-form-checkbox v-model="row.item.ald" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(ats)="row">
        <b-form-checkbox v-model="row.item.ats" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(adi)="row">
        <b-form-checkbox v-model="row.item.adi" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(atm)="row">
        <b-form-checkbox v-model="row.item.atm" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(amh)="row">
        <b-form-checkbox v-model="row.item.amh" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(vmh)="row">
        <b-form-checkbox v-model="row.item.vmh" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      
      <template v-slot:cell(vmw)="row">
        <b-form-checkbox v-model="row.item.vmw" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(vmw_rta)="row">
        <b-form-checkbox v-model="row.item.vmw_rta" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(asw_rta)="row">
        <b-form-checkbox v-model="row.item.asw_rta" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>


      <template v-slot:cell(rfg)="row">
        <b-form-checkbox v-model="row.item.rfg" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(rfi)="row">
        <b-form-checkbox v-model="row.item.rfi" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>
      <template v-slot:cell(rsg)="row">
        <b-form-checkbox v-model="row.item.rsg" @change="enableSave(row)" value:true disabled></b-form-checkbox>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="trigger-icons">
          <b-icon v-if="row.item.wasEdited" :title="$t('salvar-ativacao-de-novos-gatilhos')"
            class="config-user save-trigger" icon="check" @click="saveTrigger(row)" aria-hidden="true"></b-icon>
          <b-icon :title="$t('editar-gatilho')" class="config-user" icon="pencil-fill" @click="changeAction(row)"
            aria-hidden="true"></b-icon>
          <b-icon v-if="user.Permissions.exlcuirgatilhos.allowed" :title="$t('apagar-gatilho')" class="config-user"
            icon="trash-fill" @click="deleteTrigger(row)" aria-hidden="true"></b-icon>
        </div>
      </template>
    </b-table>

    <b-modal id="askSwitchEnableTriggers" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true"
      @hide="handleModalClose">
      <MessageBox
        :question="(enableTrigger ? $t('deseja-ativar-o-modulo-de-gatilhos') : $t('deseja-desativar-o-modulo-de-gatilhos'))"
        v-bind:action="switchEnableTriggers" @cancelAction="rollbackTriggers($event)"
        modelname="askSwitchEnableTriggers" />
    </b-modal>

  </b-card>
</template>

<script>
import FieldsDeviation from "../tools/TriggerList"
import { mapState } from 'vuex';
import MessageBox from "../../template/MessageBoxModal.vue";
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import axios from "axios";
import MediatorTrigger from "../tools/MediatorTrigger";

export default {
  name: "TriggerTable",
  computed: mapState(["user"]),
  components: { MessageBox },
  props: ["deviationList", "isRta"],
  data() {
    return {
      fields: FieldsDeviation.fields.map(f => ({ ...f, label: this.$t(f.label) })),
      items: [],
      options: {},
      loadingTrigger: true,
      enableTrigger: false,
      transientTriggerEnable: false,
      triggerFilter: "",
      actionConfirmed: false,
    }
  },
  watch: {
    triggerFilter(value) {
      if (value && value.length > 2)
        this.items = this.itemsbkp.filter(g => JSON.stringify(g).toLocaleUpperCase().includes(value.toLocaleUpperCase()))
      else
        this.items = this.itemsbkp
    },

    deviationList() {
      this.loadTrigger()
    },

    enableTrigger() {
      if (!this.loadingTrigger) {
        this.transientTriggerEnable = this.enableTrigger;
        this.$bvModal.show("askSwitchEnableTriggers");
      }
    }
  },
  methods: {
    async getEnable() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then((res) => {
          this.enableTrigger = res.data.enableTrigger;
          setTimeout(() => this.loadingTrigger = false, 300)
        })
        .catch();
    },

    rollbackTriggers() {
      this.loadingTrigger = true;
      this.enableTrigger = !this.transientTriggerEnable;
      setTimeout(() => this.loadingTrigger = false, 300)
    },

    async switchEnableTriggers() {
      this.actionConfirmed = true;
      const url = `${urlMainAPI}/enabletriggerservice/${this.transientTriggerEnable}`;
      axios.get(url)
        .then((res) => {
          defaultSuccess(res.data)
        })
        .catch((er) => {
          showError(er.data);
        });
    },
    loadTrigger() {
      this.itemsbkp = this.deviationList.map(d => {
        const item = { ...d };

        if (this.isRta) {
          // marca checkboxes conforme triggercode
          switch (item.triggercode) {
            case 'ADI_RTA': item.adi = true; break;
            case 'ALD_RTA': item.ald = true; break;
            case 'VMD_RTA': item.vmd = true; break;
            case 'VFR_RTA': item.vfr = true; break;
          }

          // ---------------- NOVO BLOCO ----------------
          // se IDs não vieram explícitos, extrai do item.key
          if (item.key && (item.processId == null || item.productId == null || item.equipmentId == null)) {
            const [, , , pId, prodId, equipId] = item.key.split('-').map(Number);
            item.processId   ??= pId;
            item.productId   ??= prodId;
            item.equipmentId ??= equipId;
          }
          // --------------------------------------------

          // fallback nos selects atuais (garante algo mesmo antes do 1º salvamento)
          const tp = MediatorTrigger.rtaTriggers?.triggerProductions || {};
          item.processId   = item.processId   ?? tp.processId;
          item.productId   = item.productId   ?? tp.productId;
          item.equipmentId = item.equipmentId ?? tp.equipmentId;
        }

        return item;
      });

      this.items = this.itemsbkp;
    },

    enableSave(row) {
      row.item.wasEdited = true;
    },
    changeAction(row) {
      row.item.wasEdited = false;
      MediatorTrigger.notify(row.item, "editTriggerInList")
      this.scrollUp()
    },
    saveTrigger(row) {
      row.item.wasEdited = false;
      this.$emit("saveTrigger", row.item)
    },
    deleteTrigger(row) {
      this.$emit("deleteTrigger", row.item)
    },
    scrollUp() {
      setTimeout(() => {
        let content = document.querySelector(".content")
        if (content && content.scrollTop > 0) {
          content.scrollTop -= 20
          this.scrollUp()
        }
      }, 7);
    },
    handleModalClose() {
   
      if (!this.actionConfirmed) {
        this.rollbackTriggers();
      }
     
      this.actionConfirmed = false;
    }

  },
  mounted() {
    this.getEnable();
    MediatorTrigger.notify(this, "initTriggerList")
    console.log("Fields antes do filtro:", this.fields);
    console.log("Items antes do filtro:", this.items);
    
    if(!this.isRta || this.isRta == false){
      this.fields = this.fields.filter(i => !['rsg','rfg','rfi','vmw_rta','asw_rta'].includes(i.key.toLowerCase()))

    }else{
      const allowedFields = ['ald', 'adi', 'vmd', 'vfr', 'rfg', 'rfi', 'rsg', 'vmw_rta', 'asw_rta', 'process', 'product', 'equipment', 'actions'];
      this.fields = this.fields.filter(i => allowedFields.includes(i.key.toLowerCase()));
    }
    
    console.log("Fields após o filtro:", this.fields);
    console.log("Items após o filtro:", this.items);
  },
}
</script>

<style scoped src="../style.css"></style>
<style scoped>
.filter-trigger {
  display: flex;
  min-width: 400px;
  max-width: 500px;
}

.filter-trigger>label {
  margin-left: 8px !important;
}

#filter-trigger {
  width: 200px;
  text-align: left;
}

.ativo {
  color: #ff5f00;
}

.desativo {
  color: red;
}

.table-limit {
  height: 350px;
  width: 948.400;
  overflow-y: auto;
  box-shadow: 0 0 2px #0003;
  border-radius: 4px;
}
</style>

<style>
.table-limit>table>thead {
  position: sticky;
  width: 948.400;
  top: 0;
  background-color: #343a40;
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  z-index: 2;
}
</style>